/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

	import * as global from "../../../js/global";
	import * as helper from "../../../js/helper";
	import full_loading from "../../components/full-loading.vue";
	const __vue_script__ ={
        components: {
            full_loading:full_loading,
        },
		name:'agencies-list',
        props: { 
        },
		data() {
			return {
                global,
                helper,
                frappe,
                is_loading:false,
				agencies: [],
                filters: [],
                action: 'Transfer',
                transfer_to: 'Agency',
                selected_agency: null,
			}
		},
        mounted(){
            this.load_data(true);
        },
		methods: {
            load_data: async function(reload=false){
                if(this.is_loading)
                    return;
                if(reload){
                    while(this.agencies.length > 0) {
                        this.agencies.pop();
                    }
                }
                global.emitter.emit("show-full-loading");
                this.is_loading = true;
                let params = {
                    // 'filters':JSON.stringify(this.filters)
                };
                let url = "/api/method/maalek.api.get_registered_agencies";
                let res = await $.ajax({
                    url: url,
                    type: "GET",
                    data: params
                });
                for (let index = 0; index < res.message.length; index++) {
                    res.message[index]['creation'] = new Date(res.message[index]['creation']);
                    this.agencies.push(res.message[index]);
                }
                this.is_loading = false;
                global.emitter.emit("hide-full-loading");
            },
            confirm_leave_agency: function(){
                bootbox.confirm({
                        message: `<div class="alert alert-danger" role="alert">
                            `+helper.t("You will not be able to reverse this action. All properties and deals will be transfer to the agency!")+`
                        </div>
                        <p>
                            `+helper.t("Do you realy want to leave this agency {0} ?",[this.selected_agency['full_name']])+`
                        </p>`,
                        buttons: {
                            confirm: {
                                label: helper.t("Yes"),
                                className: 'btn-success'
                            },
                            cancel: {
                                label: helper.t("No"),
                                className: 'btn-danger'
                            }
                        },
                        backdrop: true,
                        callback: (results) => results?this.leave_agency():console.log("cancel"),
                    });
            },
            leave_agency: async function(){
				try {
					global.emitter.emit("show-full-loading");
					let params = {
                        'agency': this.selected_agency['agency'],
                    };
                    
					let res = await $.ajax({
						headers: { 'X-Frappe-CSRF-Token': frappe.csrf_token },
						url: "/api/method/maalek.api.leave_agency",
						type: "POST",
						// data: params //for GET request
						data: JSON.stringify(params) //for POST request
					});
					global.emitter.emit("hide-full-loading");
                    helper.showSuccess(helper.t("You left the agency of {0}",[this.selected_agency['full_name']]),()=>{
						location.reload();
					});
				} catch (e) {
					global.emitter.emit("hide-full-loading");
                    var exceptions = helper.showException(e);
				}
			},
            openModal: function(elementID){
				$(elementID).modal('show');
			},
            closeModal: function(elementID){
				$(elementID).modal('hide');
			}
		},
		computed:{
		}
	}

/* template */
var __vue_render__ = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("table", { staticClass: "table align-middle" }, [
      _c("thead", [
        _c("tr", [
          _c("th", { attrs: { scope: "col" } }, [
            _vm._v(_vm._s(_vm.helper.t("Joining Date")))
          ]),
          _vm._v(" "),
          _c("th", { attrs: { scope: "col" } }, [
            _vm._v(_vm._s(_vm.helper.t("Name")))
          ]),
          _vm._v(" "),
          _c("th", { attrs: { scope: "col" } }, [
            _vm._v(_vm._s(_vm.helper.t("Contact#")))
          ]),
          _vm._v(" "),
          _c("th", { attrs: { scope: "col" } }, [
            _vm._v(_vm._s(_vm.helper.t("Properties")))
          ]),
          _vm._v(" "),
          _c("th", { attrs: { scope: "col" } }, [
            _vm._v(_vm._s(_vm.helper.t("Pending")) + " "),
            _c("i", { staticClass: "fa-regular fa-message" })
          ]),
          _vm._v(" "),
          _c("th", { attrs: { scope: "col" } })
        ])
      ]),
      _vm._v(" "),
      _c(
        "tbody",
        _vm._l(_vm.agencies, function(agency) {
          return _c("tr", [
            _c("th", { attrs: { dir: "ltr" } }, [
              _vm._v(
                _vm._s(
                  agency["creation"].getDate() +
                    "-" +
                    _vm.global.global_params.months[
                      agency["creation"].getMonth()
                    ] +
                    "-" +
                    agency["creation"].getFullYear()
                )
              )
            ]),
            _vm._v(" "),
            _c("td", {}, [_vm._v(_vm._s(agency["full_name"]))]),
            _vm._v(" "),
            _c("td", { attrs: { scope: "row" } }, [
              _vm._v(_vm._s("0" + agency["agency"].substring(4)))
            ]),
            _vm._v(" "),
            _c("td", {}, [_vm._v(_vm._s(agency["num_properties"]))]),
            _vm._v(" "),
            _c("td", {}, [_vm._v(_vm._s(agency["pending_messages_count"]))]),
            _vm._v(" "),
            _c("td", {}, [
              _c(
                "div",
                {
                  staticClass: "btn-group",
                  attrs: { role: "group", "aria-label": "Basic example" }
                },
                [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-primary",
                      attrs: { type: "button" },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          _vm.action = "Remove"
                          _vm.selected_agency = agency
                          _vm.confirm_leave_agency()
                        }
                      }
                    },
                    [_c("i", { staticClass: "fa-solid fa-trash" })]
                  )
                ]
              )
            ])
          ])
        }),
        0
      )
    ])
  ])
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-d50d43ba_0", { source: "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n", map: {"version":3,"sources":[],"names":[],"mappings":"","file":"agencies-list.vue"}, media: undefined })

  }
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "../maalek/maalek/public/vue/widgets/agency/agencies-list.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (true) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  function __vue_create_injector__() {
    const styles = __vue_create_injector__.styles || (__vue_create_injector__.styles = {})
    const isOldIE =
      typeof navigator !== 'undefined' &&
      /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase())

    return function addStyle(id, css) {
      if (document.querySelector('style[data-vue-ssr-id~="' + id + '"]')) return // SSR styles are present.

      const group = isOldIE ? css.media || 'default' : id
      const style = styles[group] || (styles[group] = { ids: [], parts: [], element: undefined })

      if (!style.ids.includes(id)) {
        let code = css.source
        let index = style.ids.length

        style.ids.push(id)

        if (false && css.map) {
          // https://developer.chrome.com/devtools/docs/javascript-debugging
          // this makes source maps inside style tags work properly in Chrome
          code += '\n/*# sourceURL=' + css.map.sources[0] + ' */'
          // http://stackoverflow.com/a/26603875
          code +=
            '\n/*# sourceMappingURL=data:application/json;base64,' +
            btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) +
            ' */'
        }

        if (isOldIE) {
          style.element = style.element || document.querySelector('style[data-group=' + group + ']')
        }

        if (!style.element) {
          const head = document.head || document.getElementsByTagName('head')[0]
          const el = style.element = document.createElement('style')
          el.type = 'text/css'

          if (css.media) el.setAttribute('media', css.media)
          if (isOldIE) {
            el.setAttribute('data-group', group)
            el.setAttribute('data-next-index', '0')
          }

          head.appendChild(el)
        }

        if (isOldIE) {
          index = parseInt(style.element.getAttribute('data-next-index'))
          style.element.setAttribute('data-next-index', index + 1)
        }

        if (style.element.styleSheet) {
          style.parts.push(code)
          style.element.styleSheet.cssText = style.parts
            .filter(Boolean)
            .join('\n')
        } else {
          const textNode = document.createTextNode(code)
          const nodes = style.element.childNodes
          if (nodes[index]) style.element.removeChild(nodes[index])
          if (nodes.length) style.element.insertBefore(textNode, nodes[index])
          else style.element.appendChild(textNode)
        }
      }
    }
  }
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    __vue_create_injector__,
    undefined,
    undefined
  )

  export default __vue_component__